// extracted by mini-css-extract-plugin
export var deleteIcon = "_tv-5";
export var deleteOption = "_tv-3";
export var divider = "_tv-2";
export var downloadIcon = "_tv-4";
export var drawer = "_tv-0";
export var drawerFooter = "_tv-6";
export var drawerOpen = "_tv-1";
export var highlighted = "_tv-7";
export var lighterHighlight = "_tv-8";